// extracted by mini-css-extract-plugin
module.exports = {"preview__types":"Channels_preview__types__1Y5QX","unauthorized":"Channels_unauthorized__GbM4k"};